export const CUSTOM_DATES_TITLE = 'Custom dates';

const safetyIntervalMinutes = 30;
const safetyIntervalSeconds = 35;

export const dateFilterItems: { title: string; duration?: { start: Duration; end?: Duration } }[] =
  [
    {
      title: 'Last hour',
      duration: { start: { hours: 1 }, end: { seconds: safetyIntervalSeconds } },
    },
    {
      title: 'Last 3 hours',
      duration: { start: { hours: 3 }, end: { seconds: safetyIntervalSeconds } },
    },
    {
      title: 'Last day',
      duration: { start: { days: 1 }, end: { minutes: safetyIntervalMinutes } },
    },
    {
      title: 'Last week',
      duration: { start: { weeks: 1 } },
    },
    {
      title: 'Last month',
      duration: { start: { months: 1 } },
    },
    {
      title: CUSTOM_DATES_TITLE,
    },
  ];
